import styles from './styles.module.scss'
import { Icon } from 'shared/ui/Icon'
import { User } from 'shared/assets/icons'
import classNames from 'classnames'

type IAvatarProps = {}

export const Avatar = ({}: IAvatarProps) => {
  const isEmpty = true
  return (
    <div className={classNames(styles.wrap, { [styles.empty]: isEmpty })}>
      {isEmpty && (
        <Icon color={'--primary-color-gray-2'}>
          <User />
        </Icon>
      )}
    </div>
  )
}
